import { formatPriceKrw } from '@/pages/SealedVinylPage/lib/utils'

import {
  SummaryContainer,
  SummaryDivider,
  SummaryFreeBadge,
  SummaryLabel,
  SummaryRow,
  SummaryTotalLabel,
  SummaryTotalValue,
  SummaryValue,
} from './styles'

interface PaymentSummaryCardProps {
  itemAmount: number
  deliveryFee: number
  totalAmount: number
}

export function PaymentSummaryCard({ itemAmount, deliveryFee, totalAmount }: PaymentSummaryCardProps) {
  const isItemFree = itemAmount === 0

  return (
    <SummaryContainer>
      <SummaryRow>
        <SummaryLabel>총 상품금액</SummaryLabel>
        {isItemFree ? (
          <SummaryFreeBadge>무료</SummaryFreeBadge>
        ) : (
          <SummaryValue>{formatPriceKrw(itemAmount)}원</SummaryValue>
        )}
      </SummaryRow>
      <SummaryRow>
        <SummaryLabel>총 배송비</SummaryLabel>
        <SummaryValue>{formatPriceKrw(deliveryFee)}원</SummaryValue>
      </SummaryRow>
      <SummaryDivider />
      <SummaryRow>
        <SummaryTotalLabel>총 결제 금액</SummaryTotalLabel>
        <SummaryTotalValue>{formatPriceKrw(totalAmount)}원</SummaryTotalValue>
      </SummaryRow>
    </SummaryContainer>
  )
}
